<template>
     <div class="login_wrap">
        <div class="container">
            <div class="title_login">
                <h2>{{get_local_string.string_75}}</h2>
                  <span>{{get_local_string.string_76}}</span>
            </div>
            <div @submit.prevent="submit()" class="login_form">
                <form class="uk-form-stacked" id="login_form">
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">{{get_local_string.string_77}}</label>
                        <div class="uk-form-controls">
                            <input v-model="login.username" @keyup="write_email()"  class="uk-input" required name="email" type="email" placeholder="Skriv epost">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">{{get_local_string.string_78}}</label>
                        <div class="uk-form-controls">
                            <input v-model="login.password" @keyup="write_pass()" class="uk-input" required name="password" type="password" placeholder="passord">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <b-button  :disabled="disabled" :loading="isLoading"  class="uk-button uk-sunmi" native-type="submit">{{get_local_string.string_75}}<i class="fas fa-sign-in-alt"></i></b-button>
                    </div>
                    <div class="uk-margin controll_opt">
                        <router-link to="/forget-password">{{get_local_string.string_79}}</router-link>
                        <router-link to="/Signup">{{get_local_string.string_80}}</router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
 import {mapActions, mapGetters} from 'vuex';
export default {
    name:'loginApp',
     data(){
       return{
           login:{
            username:'',
            password:''
        },
        isLoading: false,
        disabled: true,
       }
   },
   props:['animation'],
    computed:{
            ...mapGetters({
                loginStatus:'auth/loginStatus',
                 user:'auth/user',
                  get_setting_app:'get_setting_app',
                   get_local_string:'get_local_string'
            })
        },
   methods:{
        ...mapActions({
            signIn: 'auth/signIn'
        }),
         submit(){
         this.isLoading= true;
          this.signIn(this.login).then(()=>{
                if(this.loginStatus == 200)
                {
                    // close loading
                this.isLoading = false
                this.errorMsg='Login <b>Successflly.</b> Hi: ' + this.login.username;
                this.success();
                if(this.user.is_vaild == 0)
                {
                     this.$router.replace('/ActiveMobile');
                }
                else{
                      this.$router.replace('/Meny');
                }
                }
                else{
                // close loading
                this.isLoading = false
                this.errorMsg='Login <b>Failed.</b> error in email or password';
                this.danger();
                }
            })
        },
        write_email(){
            if(this.login.username=='' || this.login.password.length<8){
                this.disabled = true;
            }else{
                 this.disabled = false;
            }
        },
        write_pass(){
            if(this.login.password.length<8 || this.login.username==''){
                this.disabled = true;
            }else{
                 this.disabled = false;
            }
        },
          success() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-success',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
                danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
   }   
}
</script>


<style lang="scss" scoped>
.login_wrap{
    margin: 0px 0px 0px 0px;
    padding-top: 260px;
      padding-bottom: 50px;
    background-image: url('../../assets/login11.jpeg') !important;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    min-height: 100vh;
    margin-top: -45px;
     z-index: 1;
    position: relative;
     .button[disabled], fieldset[disabled] .button {
    background-color: #4c4a44;
    border-color: #dbdbdb;
    -webkit-box-shadow: none;
    box-shadow: none;
    opacity: 0.8;
}
}
.title_login{
    text-align: center;
}
.title_login h2{
    color: #fff;
    margin-bottom: 1px;
    font-family: 'medbaba';
    text-transform: uppercase;
      font-weight: 600;
     text-shadow: 0px 1px 2px #432613;
}
.title_login span{
        // margin: 10px 0 0 0 !important;
        // color: rgb(175, 175, 175);
        // font-size: 14px;
        // letter-spacing: 0.03rem;
        // font-weight: 300;
    margin: 10px 0 0 0 !important;
    color: #f1f1f1;
    font-size: 16px;
    letter-spacing: 0.03rem;
    font-weight: 500;
    text-shadow: 0px 1px 2px #432613;
    }
.login_form.register{
    max-width: 630px;  
}
.login_form{
    // max-width: 530px;
    // margin: 0 auto;
    // border: 1px solid #5c5c5ca6;
    // padding: 34px 38px 14px 38px;
    // text-align: left;
    //  background-color:#12121087;
    // margin-top: 30px;
    // border-radius: 4px;
    // position: relative;
    max-width: 530px;
    margin: 0 auto;
    border: 1px solid #0e0401;
    padding: 34px 38px 14px 38px;
    text-align: left;
    background-color: #292929ba;
    margin-top: 30px;
    border-radius: 4px;
    position: relative;
}
.login_form input{
    background-color: rgba(255,255,255,.1);
    color: rgba(255,255,255,.7);
    background-clip: padding-box;
    border-color: rgba(255,255,255,.2);
}
.uk-form-label {
    // color: rgb(175, 175, 175);
    color: #fafafa;
    font-size: .875rem;
}
.login_form input{
    border-radius: 4px;
}
.uk-sunmi{
    background-color: var(--active_color);
    color: white;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: 0.2s linear;
}
.uk-sunmi:hover{
    background-color: white;
    border: 1px solid var(--active_color);
    color: var(--active_color);
    transform: scale(1.05);
    border-radius: 4px;
}
.controll_opt{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
}
.controll_opt a{
    color: white;
    font-size: 13px;
    transition: 0.2s linear;
}
.controll_opt a:hover{
    color: var(--active_color);
    transform: scale(1.05);
}
.uk-form-controls{
    position: relative;
}
input.error, input.error:focus {
color: #f0506e !important;
 border-color: #f0506e !important;
}
input.valid, input.valid:focus {
color: #32d296 !important;
border-color: #32d296 !important;
}
label.error{
    color: #f0506e;
position: absolute;
bottom: -27px;
right: 0;
font-size: 13px;
}
</style>